module.exports = __webpack_public_path__ + "img/community-norm-me_zh.2b065650.png";